// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep mat-cell, mat-footer-cell, mat-header-cell {
   display: block !important;
   min-height: auto !important;
}

::ng-deep mat-footer-row, mat-header-row, mat-row {
   padding: 0 24px !important;
}

.link {
   font-size: 10px;
   cursor: pointer;
   color: #00b2c9;
}

.thumbnail-wrapper {
   /*background-image: url(../img/ndse/diagram-outlines.svg);*/
   background-position: -41px 0;
   background-repeat: no-repeat;
   background-size: 370px 75px;
   display: inline-block;
   height: 75px;
   margin: 0;
   overflow: hidden;
   padding: 16px 0;
   text-align: center;
   width: 75px;
}

.thumbnail-contents-start {
   background-color: #008938;
   border: 2px solid rgba(0, 0, 0, .1);
   border-radius: 50%;
   display: inline-block;
   height: 40px;
   line-height: 40px;
   margin: 1px 3px;
   width: 40px;
}

.thumbnail-contents {
   background-color: #1bbf89;
   border: 2px solid rgba(0, 0, 0, .1);
   border-radius: 10px;
   display: inline-block;
   height: 40px;
   line-height: 40px;
   margin: 1px 3px;
   width: 100px;
}

.thumbnail-contents.recipient-completed {
   background-color: #008938;
   border-color: rgba(0, 0, 0, .1);
}

.strong, .text-strong, .u-text-strong, strong {
   font-weight: 700;
}

table {
   display: table;
   border-collapse: separate;
   border-spacing: 2px;
   border-color: grey;
}

.diagram-container table, .diagram-container tbody, .diagram-container td {
   display: block;
}

.diagram-row-contents {
   padding: 0 8px;
}

.diagram-row, .diagram-row-caption, .diagram-row-contents {
   height: 75px;
}

.centered, .text-center, .u-text-center {
   text-align: center;
}

td, th {
   padding: 0;
}

*, ::after, ::before {
   box-sizing: inherit;
}

td, th {
   display: table-cell;
   vertical-align: inherit;
}

.modal-content {
   background: #fff;
   border: 1px solid #ccc;
   border-radius: 2px;
   box-shadow: 2px 2px 7px 0 rgba(0, 0, 0, .25);
   display: inline-block;
   margin: 0 auto 2em auto;
   max-width: 100%;
   min-width: 200px;
   opacity: 0;
   padding: 0;
   position: relative;
   text-align: left;
   transition: margin .3s, opacity .3s;
   vertical-align: middle;
   width: 500px;
}

.modal.modal-wrap {
   background: rgba(0, 0, 0, .5);
   border: 0;
   border-radius: 0;
   box-shadow: none;
   display: block;
   height: 100%;
   left: 0;
   margin: 0;
   max-height: none;
   max-width: none;
   outline: 0 !important;
   overflow: auto;
   padding: 0 2em;
   position: fixed;
   text-align: center;
   top: 0;
   transform: none;
   width: 100%;
   z-index: 500;
}

.modal {
   background-color: #fff;
   border: 1px solid #ccc;
   border-radius: 2px;
   box-shadow: 2px 2px 7px 0 rgba(0, 0, 0, .25);
   display: flex;
   flex-direction: column;
   left: 50%;
   margin: 36px 0;
   max-height: calc(100vh - 36px * 2);
   max-width: calc(100% - 48px);
   min-height: 0;
   min-width: 320px;
   position: fixed;
   top: 0;
   transform: translateX(-50%);
   z-index: 700;
}

.wf-sign {
   border: 3px solid #000;
   background-color: rgba(204, 223, 231, 0.67);
}

.wf-active {
   border: 3px solid #45e76f;
   background-color: rgba(204, 223, 231, 0.67);
}

.wf-inactive {
   border: 3px solid #a7a6a6;
   background-color: rgba(204, 223, 231, 0.67);
}

.wf-nonsign {
   border: 3px solid #a7a6a6;
   background-color: #a7a6a6;
}

.wf-reject {
   border: 3px solid red;
   background-color: rgba(204, 223, 231, 0.67);
}

.box-item-sender-inactive {
   border: 3px solid #a7a6a6;
}

.box-item-sender-active {
   border: 3px solid #000;
}

.box-item-sender {
   text-align: center;
   border-radius: 50%;
   width: 50px;
   height: 50px;
   margin-bottom: -4px;
}

.box-item-signer {
   width: 140px;
   height: auto;
   min-height: 50px; /* for IE as it does not support min-height */
   height:auto !important;
   border-radius: 25px;
   text-align: center;
}

.box-item-completed {
   width: 50px;
   height: 50px;
}

/* Tooltip container */
.tooltip {
   position: relative;
   display: inline-block;
}

/* Tooltip text */
.tooltip .tooltiptext {
   visibility: hidden;
   box-shadow: 2px 2px 0 rgba(0, 0, 0, .15);
   width: 180px;
   /* width: 120px; */
   background-color: rgba(224, 228, 222, 1);
   color: #000;
   text-align: center;
   padding: 10px;
   border-radius: 6px;

   /* Position the tooltip text */
   position: absolute;
   z-index: 300;
   bottom: 125%;
   right: -15%;
   margin: 0 auto;

   /* Fade in tooltip */
   opacity: 0;
   transition: opacity 0.3s;
}

/* Tooltip arrow */
.tooltip .tooltiptext::after {
   content: "";
   position: absolute;
   top: 95%;
   left: 50%;
   margin-left: -5px;
   border-width: 12px;
   border-style: solid;
   border-color: rgba(224, 228, 222, 1) transparent transparent transparent;
}

/* Show the tooltip text when you mouse over the tooltip container */
.tooltip:hover .tooltiptext {
   visibility: visible;
   opacity: 1;
   z-index: 1010;
}

/* Tooltip text */
.tooltip .tooltipsender {
   visibility: hidden;
   box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .15);
   max-width: 300px;
   /* width: 120px; */
   background-color: rgba(224, 228, 222, 1);
   color: #000;
   text-align: center;
   padding: 10px;
   border-radius: 6px;

   /* Position the tooltip text */
   position: absolute;
   z-index: 300;
   /* bottom: 125%;
   left: 50%;
   margin-left: -60px;*/

   /* Fade in tooltip */
   opacity: 0;
   transition: opacity 0.3s;
}

/* Show the tooltip text when you mouse over the tooltip container */
.tooltip:hover .tooltipsender {
   visibility: visible;
   opacity: 1;
   z-index: 1010;
}

.tooltip-right {
   top: 1px;
   left: 125%;
}

.tooltip-right::after {
   content: "";
   position: absolute;
   top: 50%;
   right: 100%;
   margin-top: -12px;
   border-width: 12px;
   border-style: solid;
   border-color: transparent rgba(224, 228, 222, 1) transparent transparent;
}

.customWidthClass {
   flex: 0 0 20px;
}

.signWidthClass {
   flex: 0 0 80px;
}

.toolbar {
   align-items: center;
   /* width: 100%; */
   margin-left: -20px;
}

.toolbar_two {
   margin-left: 67px;
}

.toolbar_div_more {
   /* margin-left: 25px; */
}

.toolbar_more {
   float: left;
}

.toolbar_two_tp {
   margin-left: 242px
}

.toolbar_three_tp {
   margin-left: 175px
}

.toolbar_four_tp {
   margin-left: 110px
}

.toolbar_more_tp {
   margin-left: 40px
}

.line_img {
   margin-top: -5px;
   margin-bottom: -6px;
   height: 23px
}

.menu > li {
   /*float: left;*/
}

.menu > li {
   margin-left: 1em;
   margin-top: 5px;
   margin-bottom: 5px;
}

.menu > li > a {
   border: 1px solid #bdc3c7;
   border-radius: 2px;
   cursor: pointer;
   display: block;
   padding: 5px 1em;
   position: relative;
   white-space: nowrap;
}

.menu > li > a:hover {
   background-color: #f7f7f7;
   color: #3d464d;
   text-decoration: none;
}

.toolbar .dropdown.open > a {
   background-color: #ebebeb;
   border-color: #bdc3c7;
}

.menu > li > a > i {
   font-size: 16px;
   margin-right: 10px;
}

.menu button {
   padding: 0 12px;
}

.menu button.mat-primary {
   line-height: 30px;
}

.menu button:not(.mat-primary) {
   border: 1px solid #bdc3c7;
   line-height: 28px;
}

.menu button i {
   font-size: 16px;
   margin-right: 10px;
}

.separator {
   border: none;
   border-top: 1px solid #eaeaea;
   height: 0;
   margin: 5px 0;
}

.toolbar .dropdown-menu {
   left: auto;
   right: 0;
}

::ng-deep .mat-cell, .mat-header-cell {
   overflow: visible;
}

[data-tooltip] {
   position: relative;
}

[data-tooltip]:before,
[data-tooltip]:after {
   display: none;
   position: absolute;
   top: 0;
}

[data-tooltip]:before {
   border-bottom: .6em solid #09f;
   border-bottom: .6em solid rgba(0, 153, 255, 0.8);
   border-left: 7px solid transparent;
   border-right: 7px solid transparent;
   content: "";
   left: 20px;
   margin-top: 1em;
}

[data-tooltip]:after {
   background-color: #0099ff;
   background-color: rgba(0, 153, 255, 0.8);
   border: 4px solid #0099ff;
   border: 4px solid rgba(0, 153, 255, 0.8);
   border-radius: 7px;
   color: #ffffff;
   content: attr(data-tooltip-label) ":\\A" attr(data-tooltip-message);
   left: 0;
   margin-top: 1.5em;
   padding: 5px 15px;
   white-space: pre-wrap;
   width: 100px;
}

[data-tooltip]:hover:after,
[data-tooltip]:hover:before {
   display: block;
}

.mat_tooltip {
   white-space: pre-line;
}

.line-2 {
   display: block;
   font-size: 10px;
   line-height: 1;
   margin-top: 3px;
}

.line-sign {
   display: block;
   font-size: 9px;
   line-height: 1;
   margin-top: 3px;
}

.ul-flow {
   list-style-type: none;
   justify-content: center;
   -webkit-padding-start: 0px;
   -webkit-margin-before: 0px;
   -webkit-margin-after: 0px;
}

.ul-flow-less {
   display: flex;
}

.ul-flow-more {
   margin-left: 50px !important;
}

.li-flow {
   padding: 5px 8px;
}
`, "",{"version":3,"sources":["webpack://./src/app/e-signature/view-flow/flow/flow.component.css"],"names":[],"mappings":"AAAA;GACG,yBAAyB;GACzB,2BAA2B;AAC9B;;AAEA;GACG,0BAA0B;AAC7B;;AAEA;GACG,eAAe;GACf,eAAe;GACf,cAAc;AACjB;;AAEA;GACG,2DAA2D;GAC3D,4BAA4B;GAC5B,4BAA4B;GAC5B,2BAA2B;GAC3B,qBAAqB;GACrB,YAAY;GACZ,SAAS;GACT,gBAAgB;GAChB,eAAe;GACf,kBAAkB;GAClB,WAAW;AACd;;AAEA;GACG,yBAAyB;GACzB,mCAAmC;GACnC,kBAAkB;GAClB,qBAAqB;GACrB,YAAY;GACZ,iBAAiB;GACjB,eAAe;GACf,WAAW;AACd;;AAEA;GACG,yBAAyB;GACzB,mCAAmC;GACnC,mBAAmB;GACnB,qBAAqB;GACrB,YAAY;GACZ,iBAAiB;GACjB,eAAe;GACf,YAAY;AACf;;AAEA;GACG,yBAAyB;GACzB,+BAA+B;AAClC;;AAEA;GACG,gBAAgB;AACnB;;AAEA;GACG,cAAc;GACd,yBAAyB;GACzB,mBAAmB;GACnB,kBAAkB;AACrB;;AAEA;GACG,cAAc;AACjB;;AAEA;GACG,cAAc;AACjB;;AAEA;GACG,YAAY;AACf;;AAEA;GACG,kBAAkB;AACrB;;AAEA;GACG,UAAU;AACb;;AAEA;GACG,mBAAmB;AACtB;;AAEA;GACG,mBAAmB;GACnB,uBAAuB;AAC1B;;AAEA;GACG,gBAAgB;GAChB,sBAAsB;GACtB,kBAAkB;GAClB,4CAA4C;GAC5C,qBAAqB;GACrB,uBAAuB;GACvB,eAAe;GACf,gBAAgB;GAChB,UAAU;GACV,UAAU;GACV,kBAAkB;GAClB,gBAAgB;GAChB,mCAAmC;GACnC,sBAAsB;GACtB,YAAY;AACf;;AAEA;GACG,6BAA6B;GAC7B,SAAS;GACT,gBAAgB;GAChB,gBAAgB;GAChB,cAAc;GACd,YAAY;GACZ,OAAO;GACP,SAAS;GACT,gBAAgB;GAChB,eAAe;GACf,qBAAqB;GACrB,cAAc;GACd,cAAc;GACd,eAAe;GACf,kBAAkB;GAClB,MAAM;GAGN,eAAe;GACf,WAAW;GACX,YAAY;AACf;;AAEA;GACG,sBAAsB;GACtB,sBAAsB;GACtB,kBAAkB;GAClB,4CAA4C;GAG5C,aAAa;GAIb,sBAAsB;GACtB,SAAS;GACT,cAAc;GACd,kCAAkC;GAClC,4BAA4B;GAC5B,aAAa;GACb,gBAAgB;GAChB,eAAe;GACf,MAAM;GAGN,2BAA2B;GAC3B,YAAY;AACf;;AAEA;GACG,sBAAsB;GACtB,2CAA2C;AAC9C;;AAEA;GACG,yBAAyB;GACzB,2CAA2C;AAC9C;;AAEA;GACG,yBAAyB;GACzB,2CAA2C;AAC9C;;AAEA;GACG,yBAAyB;GACzB,yBAAyB;AAC5B;;AAEA;GACG,qBAAqB;GACrB,2CAA2C;AAC9C;;AAEA;GACG,yBAAyB;AAC5B;;AAEA;GACG,sBAAsB;AACzB;;AAEA;GACG,kBAAkB;GAClB,kBAAkB;GAClB,WAAW;GACX,YAAY;GACZ,mBAAmB;AACtB;;AAEA;GACG,YAAY;GACZ,YAAY;GACZ,gBAAgB,EAAE,6CAA6C;GAC/D,sBAAsB;GACtB,mBAAmB;GACnB,kBAAkB;AACrB;;AAEA;GACG,WAAW;GACX,YAAY;AACf;;AAEA,sBAAsB;AACtB;GACG,kBAAkB;GAClB,qBAAqB;AACxB;;AAEA,iBAAiB;AACjB;GACG,kBAAkB;GAClB,wCAAwC;GACxC,YAAY;GACZ,kBAAkB;GAClB,wCAAwC;GACxC,WAAW;GACX,kBAAkB;GAClB,aAAa;GACb,kBAAkB;;GAElB,8BAA8B;GAC9B,kBAAkB;GAClB,YAAY;GACZ,YAAY;GACZ,WAAW;GACX,cAAc;;GAEd,oBAAoB;GACpB,UAAU;GACV,wBAAwB;AAC3B;;AAEA,kBAAkB;AAClB;GACG,WAAW;GACX,kBAAkB;GAClB,QAAQ;GACR,SAAS;GACT,iBAAiB;GACjB,kBAAkB;GAClB,mBAAmB;GACnB,wEAAwE;AAC3E;;AAEA,oEAAoE;AACpE;GACG,mBAAmB;GACnB,UAAU;GACV,aAAa;AAChB;;AAEA,iBAAiB;AACjB;GACG,kBAAkB;GAClB,0CAA0C;GAC1C,gBAAgB;GAChB,kBAAkB;GAClB,wCAAwC;GACxC,WAAW;GACX,kBAAkB;GAClB,aAAa;GACb,kBAAkB;;GAElB,8BAA8B;GAC9B,kBAAkB;GAClB,YAAY;GACZ;;uBAEoB;;GAEpB,oBAAoB;GACpB,UAAU;GACV,wBAAwB;AAC3B;;AAEA,oEAAoE;AACpE;GACG,mBAAmB;GACnB,UAAU;GACV,aAAa;AAChB;;AAEA;GACG,QAAQ;GACR,UAAU;AACb;;AAEA;GACG,WAAW;GACX,kBAAkB;GAClB,QAAQ;GACR,WAAW;GACX,iBAAiB;GACjB,kBAAkB;GAClB,mBAAmB;GACnB,wEAAwE;AAC3E;;AAEA;GACG,cAAc;AACjB;;AAEA;GACG,cAAc;AACjB;;AAEA;GACG,mBAAmB;GACnB,iBAAiB;GACjB,kBAAkB;AACrB;;AAEA;GACG,iBAAiB;AACpB;;AAEA;GACG,uBAAuB;AAC1B;;AAEA;GACG,WAAW;AACd;;AAEA;GACG;AACH;;AAEA;GACG;AACH;;AAEA;GACG;AACH;;AAEA;GACG;AACH;;AAEA;GACG,gBAAgB;GAChB,mBAAmB;GACnB;AACH;;AAEA;GACG,eAAe;AAClB;;AAEA;GACG,gBAAgB;GAChB,eAAe;GACf,kBAAkB;AACrB;;AAEA;GACG,yBAAyB;GACzB,kBAAkB;GAClB,eAAe;GACf,cAAc;GACd,gBAAgB;GAChB,kBAAkB;GAClB,mBAAmB;AACtB;;AAEA;GACG,yBAAyB;GACzB,cAAc;GACd,qBAAqB;AACxB;;AAEA;GACG,yBAAyB;GACzB,qBAAqB;AACxB;;AAEA;GACG,eAAe;GACf,kBAAkB;AACrB;;AAEA;GACG,eAAe;AAClB;;AAEA;GACG,iBAAiB;AACpB;;AAEA;GACG,yBAAyB;GACzB,iBAAiB;AACpB;;AAEA;GACG,eAAe;GACf,kBAAkB;AACrB;;AAEA;GACG,YAAY;GACZ,6BAA6B;GAC7B,SAAS;GACT,aAAa;AAChB;;AAEA;GACG,UAAU;GACV,QAAQ;AACX;;AAEA;GACG,iBAAiB;AACpB;;AAEA;GACG,kBAAkB;AACrB;;AAEA;;GAEG,aAAa;GACb,kBAAkB;GAClB,MAAM;AACT;;AAEA;GACG,8BAA8B;GAC9B,gDAAgD;GAChD,kCAAkC;GAClC,mCAAmC;GACnC,WAAW;GACX,UAAU;GACV,eAAe;AAClB;;AAEA;GACG,yBAAyB;GACzB,wCAAwC;GACxC,yBAAyB;GACzB,wCAAwC;GACxC,kBAAkB;GAClB,cAAc;GACd,kEAAkE;GAClE,OAAO;GACP,iBAAiB;GACjB,iBAAiB;GACjB,qBAAqB;GACrB,YAAY;AACf;;AAEA;;GAEG,cAAc;AACjB;;AAEA;GACG,qBAAqB;AACxB;;AAEA;GACG,cAAc;GACd,eAAe;GACf,cAAc;GACd,eAAe;AAClB;;AAEA;GACG,cAAc;GACd,cAAc;GACd,cAAc;GACd,eAAe;AAClB;;AAEA;GACG,qBAAqB;GACrB,uBAAuB;GACvB,0BAA0B;GAC1B,0BAA0B;GAC1B,yBAAyB;AAC5B;;AAEA;GACG,aAAa;AAChB;;AAEA;GACG,4BAA4B;AAC/B;;AAEA;GACG,gBAAgB;AACnB","sourcesContent":["::ng-deep mat-cell, mat-footer-cell, mat-header-cell {\n   display: block !important;\n   min-height: auto !important;\n}\n\n::ng-deep mat-footer-row, mat-header-row, mat-row {\n   padding: 0 24px !important;\n}\n\n.link {\n   font-size: 10px;\n   cursor: pointer;\n   color: #00b2c9;\n}\n\n.thumbnail-wrapper {\n   /*background-image: url(../img/ndse/diagram-outlines.svg);*/\n   background-position: -41px 0;\n   background-repeat: no-repeat;\n   background-size: 370px 75px;\n   display: inline-block;\n   height: 75px;\n   margin: 0;\n   overflow: hidden;\n   padding: 16px 0;\n   text-align: center;\n   width: 75px;\n}\n\n.thumbnail-contents-start {\n   background-color: #008938;\n   border: 2px solid rgba(0, 0, 0, .1);\n   border-radius: 50%;\n   display: inline-block;\n   height: 40px;\n   line-height: 40px;\n   margin: 1px 3px;\n   width: 40px;\n}\n\n.thumbnail-contents {\n   background-color: #1bbf89;\n   border: 2px solid rgba(0, 0, 0, .1);\n   border-radius: 10px;\n   display: inline-block;\n   height: 40px;\n   line-height: 40px;\n   margin: 1px 3px;\n   width: 100px;\n}\n\n.thumbnail-contents.recipient-completed {\n   background-color: #008938;\n   border-color: rgba(0, 0, 0, .1);\n}\n\n.strong, .text-strong, .u-text-strong, strong {\n   font-weight: 700;\n}\n\ntable {\n   display: table;\n   border-collapse: separate;\n   border-spacing: 2px;\n   border-color: grey;\n}\n\n.diagram-container table, .diagram-container tbody, .diagram-container td {\n   display: block;\n}\n\n.diagram-row-contents {\n   padding: 0 8px;\n}\n\n.diagram-row, .diagram-row-caption, .diagram-row-contents {\n   height: 75px;\n}\n\n.centered, .text-center, .u-text-center {\n   text-align: center;\n}\n\ntd, th {\n   padding: 0;\n}\n\n*, ::after, ::before {\n   box-sizing: inherit;\n}\n\ntd, th {\n   display: table-cell;\n   vertical-align: inherit;\n}\n\n.modal-content {\n   background: #fff;\n   border: 1px solid #ccc;\n   border-radius: 2px;\n   box-shadow: 2px 2px 7px 0 rgba(0, 0, 0, .25);\n   display: inline-block;\n   margin: 0 auto 2em auto;\n   max-width: 100%;\n   min-width: 200px;\n   opacity: 0;\n   padding: 0;\n   position: relative;\n   text-align: left;\n   transition: margin .3s, opacity .3s;\n   vertical-align: middle;\n   width: 500px;\n}\n\n.modal.modal-wrap {\n   background: rgba(0, 0, 0, .5);\n   border: 0;\n   border-radius: 0;\n   box-shadow: none;\n   display: block;\n   height: 100%;\n   left: 0;\n   margin: 0;\n   max-height: none;\n   max-width: none;\n   outline: 0 !important;\n   overflow: auto;\n   padding: 0 2em;\n   position: fixed;\n   text-align: center;\n   top: 0;\n   -webkit-transform: none;\n   -ms-transform: none;\n   transform: none;\n   width: 100%;\n   z-index: 500;\n}\n\n.modal {\n   background-color: #fff;\n   border: 1px solid #ccc;\n   border-radius: 2px;\n   box-shadow: 2px 2px 7px 0 rgba(0, 0, 0, .25);\n   display: -webkit-box;\n   display: -ms-flexbox;\n   display: flex;\n   -webkit-box-orient: vertical;\n   -webkit-box-direction: normal;\n   -ms-flex-direction: column;\n   flex-direction: column;\n   left: 50%;\n   margin: 36px 0;\n   max-height: calc(100vh - 36px * 2);\n   max-width: calc(100% - 48px);\n   min-height: 0;\n   min-width: 320px;\n   position: fixed;\n   top: 0;\n   -webkit-transform: translateX(-50%);\n   -ms-transform: translateX(-50%);\n   transform: translateX(-50%);\n   z-index: 700;\n}\n\n.wf-sign {\n   border: 3px solid #000;\n   background-color: rgba(204, 223, 231, 0.67);\n}\n\n.wf-active {\n   border: 3px solid #45e76f;\n   background-color: rgba(204, 223, 231, 0.67);\n}\n\n.wf-inactive {\n   border: 3px solid #a7a6a6;\n   background-color: rgba(204, 223, 231, 0.67);\n}\n\n.wf-nonsign {\n   border: 3px solid #a7a6a6;\n   background-color: #a7a6a6;\n}\n\n.wf-reject {\n   border: 3px solid red;\n   background-color: rgba(204, 223, 231, 0.67);\n}\n\n.box-item-sender-inactive {\n   border: 3px solid #a7a6a6;\n}\n\n.box-item-sender-active {\n   border: 3px solid #000;\n}\n\n.box-item-sender {\n   text-align: center;\n   border-radius: 50%;\n   width: 50px;\n   height: 50px;\n   margin-bottom: -4px;\n}\n\n.box-item-signer {\n   width: 140px;\n   height: auto;\n   min-height: 50px; /* for IE as it does not support min-height */\n   height:auto !important;\n   border-radius: 25px;\n   text-align: center;\n}\n\n.box-item-completed {\n   width: 50px;\n   height: 50px;\n}\n\n/* Tooltip container */\n.tooltip {\n   position: relative;\n   display: inline-block;\n}\n\n/* Tooltip text */\n.tooltip .tooltiptext {\n   visibility: hidden;\n   box-shadow: 2px 2px 0 rgba(0, 0, 0, .15);\n   width: 180px;\n   /* width: 120px; */\n   background-color: rgba(224, 228, 222, 1);\n   color: #000;\n   text-align: center;\n   padding: 10px;\n   border-radius: 6px;\n\n   /* Position the tooltip text */\n   position: absolute;\n   z-index: 300;\n   bottom: 125%;\n   right: -15%;\n   margin: 0 auto;\n\n   /* Fade in tooltip */\n   opacity: 0;\n   transition: opacity 0.3s;\n}\n\n/* Tooltip arrow */\n.tooltip .tooltiptext::after {\n   content: \"\";\n   position: absolute;\n   top: 95%;\n   left: 50%;\n   margin-left: -5px;\n   border-width: 12px;\n   border-style: solid;\n   border-color: rgba(224, 228, 222, 1) transparent transparent transparent;\n}\n\n/* Show the tooltip text when you mouse over the tooltip container */\n.tooltip:hover .tooltiptext {\n   visibility: visible;\n   opacity: 1;\n   z-index: 1010;\n}\n\n/* Tooltip text */\n.tooltip .tooltipsender {\n   visibility: hidden;\n   box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .15);\n   max-width: 300px;\n   /* width: 120px; */\n   background-color: rgba(224, 228, 222, 1);\n   color: #000;\n   text-align: center;\n   padding: 10px;\n   border-radius: 6px;\n\n   /* Position the tooltip text */\n   position: absolute;\n   z-index: 300;\n   /* bottom: 125%;\n   left: 50%;\n   margin-left: -60px;*/\n\n   /* Fade in tooltip */\n   opacity: 0;\n   transition: opacity 0.3s;\n}\n\n/* Show the tooltip text when you mouse over the tooltip container */\n.tooltip:hover .tooltipsender {\n   visibility: visible;\n   opacity: 1;\n   z-index: 1010;\n}\n\n.tooltip-right {\n   top: 1px;\n   left: 125%;\n}\n\n.tooltip-right::after {\n   content: \"\";\n   position: absolute;\n   top: 50%;\n   right: 100%;\n   margin-top: -12px;\n   border-width: 12px;\n   border-style: solid;\n   border-color: transparent rgba(224, 228, 222, 1) transparent transparent;\n}\n\n.customWidthClass {\n   flex: 0 0 20px;\n}\n\n.signWidthClass {\n   flex: 0 0 80px;\n}\n\n.toolbar {\n   align-items: center;\n   /* width: 100%; */\n   margin-left: -20px;\n}\n\n.toolbar_two {\n   margin-left: 67px;\n}\n\n.toolbar_div_more {\n   /* margin-left: 25px; */\n}\n\n.toolbar_more {\n   float: left;\n}\n\n.toolbar_two_tp {\n   margin-left: 242px\n}\n\n.toolbar_three_tp {\n   margin-left: 175px\n}\n\n.toolbar_four_tp {\n   margin-left: 110px\n}\n\n.toolbar_more_tp {\n   margin-left: 40px\n}\n\n.line_img {\n   margin-top: -5px;\n   margin-bottom: -6px;\n   height: 23px\n}\n\n.menu > li {\n   /*float: left;*/\n}\n\n.menu > li {\n   margin-left: 1em;\n   margin-top: 5px;\n   margin-bottom: 5px;\n}\n\n.menu > li > a {\n   border: 1px solid #bdc3c7;\n   border-radius: 2px;\n   cursor: pointer;\n   display: block;\n   padding: 5px 1em;\n   position: relative;\n   white-space: nowrap;\n}\n\n.menu > li > a:hover {\n   background-color: #f7f7f7;\n   color: #3d464d;\n   text-decoration: none;\n}\n\n.toolbar .dropdown.open > a {\n   background-color: #ebebeb;\n   border-color: #bdc3c7;\n}\n\n.menu > li > a > i {\n   font-size: 16px;\n   margin-right: 10px;\n}\n\n.menu button {\n   padding: 0 12px;\n}\n\n.menu button.mat-primary {\n   line-height: 30px;\n}\n\n.menu button:not(.mat-primary) {\n   border: 1px solid #bdc3c7;\n   line-height: 28px;\n}\n\n.menu button i {\n   font-size: 16px;\n   margin-right: 10px;\n}\n\n.separator {\n   border: none;\n   border-top: 1px solid #eaeaea;\n   height: 0;\n   margin: 5px 0;\n}\n\n.toolbar .dropdown-menu {\n   left: auto;\n   right: 0;\n}\n\n::ng-deep .mat-cell, .mat-header-cell {\n   overflow: visible;\n}\n\n[data-tooltip] {\n   position: relative;\n}\n\n[data-tooltip]:before,\n[data-tooltip]:after {\n   display: none;\n   position: absolute;\n   top: 0;\n}\n\n[data-tooltip]:before {\n   border-bottom: .6em solid #09f;\n   border-bottom: .6em solid rgba(0, 153, 255, 0.8);\n   border-left: 7px solid transparent;\n   border-right: 7px solid transparent;\n   content: \"\";\n   left: 20px;\n   margin-top: 1em;\n}\n\n[data-tooltip]:after {\n   background-color: #0099ff;\n   background-color: rgba(0, 153, 255, 0.8);\n   border: 4px solid #0099ff;\n   border: 4px solid rgba(0, 153, 255, 0.8);\n   border-radius: 7px;\n   color: #ffffff;\n   content: attr(data-tooltip-label) \":\\A\" attr(data-tooltip-message);\n   left: 0;\n   margin-top: 1.5em;\n   padding: 5px 15px;\n   white-space: pre-wrap;\n   width: 100px;\n}\n\n[data-tooltip]:hover:after,\n[data-tooltip]:hover:before {\n   display: block;\n}\n\n.mat_tooltip {\n   white-space: pre-line;\n}\n\n.line-2 {\n   display: block;\n   font-size: 10px;\n   line-height: 1;\n   margin-top: 3px;\n}\n\n.line-sign {\n   display: block;\n   font-size: 9px;\n   line-height: 1;\n   margin-top: 3px;\n}\n\n.ul-flow {\n   list-style-type: none;\n   justify-content: center;\n   -webkit-padding-start: 0px;\n   -webkit-margin-before: 0px;\n   -webkit-margin-after: 0px;\n}\n\n.ul-flow-less {\n   display: flex;\n}\n\n.ul-flow-more {\n   margin-left: 50px !important;\n}\n\n.li-flow {\n   padding: 5px 8px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
